import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import "./ReactivityTagIa.scss";

import {fetchCategoryRoot, resetCategoryRoot} from "../../../../../../creators/category.rootChildrens";
import {Button} from "../../../../../components/Button";


class ReactivityTagIa extends Component {
    constructor(props) {
        super(props);
        this.props.fetchCategoryRoot(this.props.currentCategory.parents[0].slug, {sort : "order"});
    }

    componentWillUnmount() {
        this.props.resetCategoryRoot()
    }


    render() {

        let categories = [];
        if(this.props.categoriesInitialized){
            categories = this.props.categories.filter(category => category._id.toString() !== this.props.currentCategory._id.toString());
        }

       /* let catNav = categories.slice(0,categoriesLength > 4 ? 3 : 4);
        let catSelect = categories.slice(categoriesLength > 4 ? 3 : 4);*/

        //let listIds = catSelect.map(item => item._id.toString());

        return (
            <div className="tag-moderations-qualification-medias-tags-ia">
                <div className={"current-category"}>
                    Veuillez vérifier la classification :
                    <Button
                        className={`${this.props.currentMediaCategory.toString() === this.props.currentCategory._id.toString() ? "category-success" : "category-error"}`}
                        content={this.props.currentCategory.title}
                        onClick={()=>this.props.updateCategory(this.props.currentCategory._id)}
                    />
                </div>
                <div className={"btn-group"}>
                    {this.props.currentCategory.parents[0].slug === "genre" ? (
                        <Button
                            btnStyle={"cancel"}
                            key={"ignorer"}
                            content={"N/A"}
                            className={`${this.props.currentMediaCategory.toString() === 'n/a' ? "category-cancel" : ""}`}
                            //onClick={()=>this.props.skipGender()}
                            onClick={()=>this.props.updateCategory('n/a')}
                        />
                    ) : null }
                    {categories.map(category =>(
                        <Button
                            key={category._id}
                            className={`${this.props.currentMediaCategory.toString() === category._id.toString() ? "category-success" : ""}`}
                            content={category.title}
                            onClick={()=>this.props.updateCategory(category._id)}
                        />
                    ))}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        categories: (state.categoryRoot.data && state.categoryRoot.data.data) || [],
        categoriesInitialized : state.categoryRoot.initialized,
        categoriesLoading : state.categoryRoot.loading,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCategoryRoot,
    resetCategoryRoot
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReactivityTagIa);